module.exports = __webpack_public_path__ + "img/p-36.4e294ccd.jpg";